import React from "react";
import { ArrowRightIcon } from "lucide-react";
const footerLinks = [{
  label: "Look inside",
  href: "#preview"
}, {
  label: "Workshops",
  href: "#workshops"
}, {
  label: "Bonuses",
  href: "#bonuses"
}, {
  label: "Pricing",
  href: "#offer-details"
}, {
  label: "FAQ",
  href: "#faq"
}];
export function SiteFooter() {
  return <footer className="site-footer" data-id="element-147" data-mp="3hhwvjo2kpedz">
      <div className="shell" data-id="element-148" data-mp="3dgutkzh9uo8b">
        <a href="#top" className="footer-brand" data-id="element-149" data-mp="3dh4kcpa54zf2">
          TEAM COMMUNICATION <span data-id="element-150" data-mp="38hrpbh948m1e">READY</span>
        </a>
        <p data-id="element-151" data-mp="38gqad1ozbfee">Volume 1: five ready-to-run workshops for everyday team communication.</p>
        <nav aria-label="Footer" data-id="element-152" data-mp="33hvizbcy4iio">
          {footerLinks.map(link => <a key={link.href} href={link.href} data-id="element-153" data-mp="2yjlpr6as7rzp">
              {link.label}
            </a>)}
          <a href="#offer-details" className="store-link" data-id="element-154" data-mp="11r1ziczu7h5e">
            See the complete offer <ArrowRightIcon size={13} aria-hidden="true" data-id="element-155" data-mp="11oxwdx9rim66" />
          </a>
        </nav>
        <p className="footer-small" data-id="element-156" data-mp="wq4hc0etun3w">English-language PDFs · Internal-team use · One-time purchase</p>
      </div>
    </footer>;
}